import { createAction, createReducer } from '../../util/redux';
import { findIndex, propEq, merge } from 'ramda';

/*
 |--------------------------------------------------------------------------
 | Default state
 |--------------------------------------------------------------------------
 */

const defaultState = {};

/*
 |--------------------------------------------------------------------------
 | Actions - anything that changes the store
 |--------------------------------------------------------------------------
 */

const UPDATE_CERTIFICATION = 'UPDATE_CERTIFICATION';
const updateCertification = createAction(UPDATE_CERTIFICATION);
function updateCertificationHandler(state, { payload }) {
  const certificationIndex = findIndex(propEq('id', payload.id))(state);
  state[certificationIndex] = merge(state[certificationIndex], payload);

  return state;
}

/*
 |--------------------------------------------------------------------------
 | Thunks - same as actions but returns a promise. Good for chaining
 |--------------------------------------------------------------------------
 */

/*
 |--------------------------------------------------------------------------
 | Reducer - maps the action to the action handler
 |--------------------------------------------------------------------------
 */

export const certificationsReducer = createReducer(defaultState, {
  [UPDATE_CERTIFICATION]: updateCertificationHandler,
});

/*
 |--------------------------------------------------------------------------
 | Action Exports
 |--------------------------------------------------------------------------
 */
export default {
  updateCertification,
};
